export const tr = {
    'banner-image-desc1':
        'Doğru seçilen görseller kullanıcıların ilgisini çekerek teklifi daha anlaşılır hale getirir.',
    'banner-image-desc2':
        "Her reklamı, standart (1:1'den 4:3/3:4'e kadar) ve geniş (16:9) ebatlı olmak üzere, iki seçenekli oluşturmanızı öneririz. Böylece reklamlarınız tüm sitelerde gösterilir.",
    'normal-view-title': 'Reklamlarınıza görsel ekleyin',
    'normal-view-title-hint': 'Bu öneriyi, görselsiz reklamlarınız olduğu için görüyorsunuz',
    'popup-view-title': 'Reklamınıza görsel ekleyin',
    'popup-view-title-hint': 'Reklamınız görselsiz olduğu için bu öneriyi görüyorsunuz',
    'show-many-banner-button': '{count} reklamı görüntüle',
    'show-one-banner-button': '{count} reklamı görüntüle',
    'show-some-banner-button': '{count} reklamı görüntüle',
    'with-image': 'Görselli',
    'without-image': 'Görselsiz'
};
